import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import styled from "styled-components";
import EventTypes from "./EventTypes";
import Filters from "./Filters";
import Venues from "./Venues";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

type OwnProps = {};
type Props = OwnProps & RouteComponentProps;

const Discover: React.FC<Props> = props => {
  return (
    <Wrapper style={{ paddingTop: 60 }}>
      <Filters />
      <EventTypes />
      <Venues />
    </Wrapper>
  );
};

export default Discover;
